import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    NewAmendmentResponse,
    TNewAmendmentResponse,
} from "../../types/devices/ttr/publishDeviceTypes"

type TStartNewAmendmentMapper = {
    map: (response: unknown) => TNewAmendmentResponse
}

export const startNewAmendmentMapper: TStartNewAmendmentMapper = {
    /** Maps response from "/start-new-amendment" endpoint to ts-io defined type */
    map: (response: unknown) =>
        tsIoValidate(NewAmendmentResponse, response, "startNewAmendmentMapper"),
}
